import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import { modalPrimaryButtonStyle } from '../styles/buttonStyles'

const AppFeaturesModal = ({
  open,
  onClose,
  onMouseEnter,
  onMouseLeave
}) => {
  const { t } = useTranslation(['translation', 'features'])
  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  if (!open) return null

  const features = t('features:features', {
    returnObjects: true
  })

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(0,0,0,0.85)',
        borderRadius: 12,
padding: window.innerWidth <= 768 ? 16 : 24,
width: window.innerWidth <= 768 ? 'calc(100vw - 48px)' : 1150,
maxWidth: window.innerWidth <= 768 ? 'calc(100vw - 48px)' : undefined,
boxSizing: 'border-box',
maxHeight: '80vh',
overflowY: 'auto',
overflowX: 'hidden',
fontSize: window.innerWidth <= 768 ? 14 : undefined,
lineHeight: window.innerWidth <= 768 ? 1.45 : undefined,
overflowWrap: 'anywhere',
        zIndex: 3600,
        border: '1.5px solid #107c6b',
        boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
        color: '#E7DFEC'
      }}
    >
      <h2 style={{ marginTop: window.innerWidth <= 768 ? 0 : -10, marginBottom: 6, fontSize: window.innerWidth <= 768 ? 20 : 24 }}>
        {t('features:FEATURES_PAGE_TITLE')}
      </h2>

      {features.map((section, i) => (
        <div key={i} style={{ marginBottom: 24 }}>
          <h3 style={{ marginBottom: 8, fontSize: window.innerWidth <= 768 ? 16 : undefined }}>{section.title}</h3>

          {section.items &&
            section.items.map((item, j) => (
              <p key={j} style={{ margin: 0 }}>
                • {item}
              </p>
            ))}

          {section.features &&
            section.features.map((sub, k) => (
              <div key={k} style={{ marginTop: 12 }}>
                <strong>{sub.title}</strong>

                {sub.items.map((subItem, m) => (
                  <p key={m} style={{ margin: 0 }}>
                    • {subItem}
                  </p>
                ))}
              </div>
            ))}
        </div>
      ))}

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: 20
        }}
      >
        <button
          onClick={onClose}
          style={modalPrimaryButtonStyle(
            pressedBtn,
            'feature-close',
            hoverBtn === 'feature-close'
          )}
          onMouseEnter={() => setHoverBtn('feature-close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('feature-close')}
          onMouseUp={() => setPressedBtn(null)}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default AppFeaturesModal